import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { SUIT_GLYPH } from '@/components/bridge/suits';
import { useBridgeAperto } from '@/components/bridge/useBridgeAperto';
import { Button } from '@/components/common/Button';

/**
 * La tessera «Bridge» della Hub (QBridge R1, L-3011 (a), I-590): UNA riga, sotto la banda del sospeso e sopra le sezioni. Porta a `/bridge`
 * (`BridgeIngresso`) e basta: l'ingresso decide cosa offrire a chi (all'ospite la prima mano, le lezioni e il minibridge, tutto senza rete).
 *
 * ⚠️ La Hub NON scorre: ogni pixel della tessera lo perdono le sezioni. Per questo e' una riga sola, alta 48 (`h-12`, mai sopra i 52).
 * La vede chi entra in QBridge (`useBridgeAperto`: beta OPPURE ospite); `Hub.tsx` la monta solo col confronto LETTERALE del flag.
 */
export function TesseraBridge() {
  const { t } = useTranslation('bridge');
  const navigate = useNavigate();
  if (!useBridgeAperto()) return null;
  return (
    <Button
      variant="neutro"
      fullWidth
      data-tessera-bridge
      className="h-12 shrink-0 justify-start gap-3 px-3 py-1 text-left"
      onClick={() => navigate('/bridge')}
    >
      <span aria-hidden className="w-6 shrink-0 text-center text-xl leading-none text-fg">
        {SUIT_GLYPH.S}
      </span>
      <span className="flex min-w-0 flex-col items-start">
        <span className="max-w-full text-sm font-semibold leading-5 text-fg">{t('tessera.titolo')}</span>
        <span className="max-w-full text-xs leading-4 text-fg-muted">{t('tessera.sottotitolo')}</span>
      </span>
    </Button>
  );
}
